import * as ScratchBlocks from 'scratch-blocks';
import PIXELBLOCK_COLORS from './pixelblock/colors.js';
import { registerPixelBlockLocales, getPixelBlockLocale } from './pixelblock';

if (ScratchBlocks && ScratchBlocks.ScratchMsgs) {
    registerPixelBlockLocales(ScratchBlocks);
}

const categorySeparator = '<sep gap="36"/>';
const blockSeparator = '<sep gap="24"/>';

const xmlOpen = '<xml style="display: none">';
const xmlClose = '</xml>';

const makeToolboxXML = function (isInitialSetup, isStage = true, targetId, categoriesXML = [],
    costumeName = '', backdropName = '', soundName = '', colors = PIXELBLOCK_COLORS) {

    if (ScratchBlocks && ScratchBlocks.ScratchMsgs) {
        registerPixelBlockLocales(ScratchBlocks);
    }

    const loc = getPixelBlockLocale();
    const isFr = loc.startsWith('fr');
    const isPy = loc === 'python';

    const helloText = isFr ? 'Bonjour !' : 'Hello!';
    const askText = isFr ? 'Quel est ton nom ?' : (isPy ? 'Enter your name: ' : "What's your name?");
    const listText = isFr ? 'ma_liste' : 'my_list';

    const col = PIXELBLOCK_COLORS;

    // 1. LOOKS / SORTIE (#9966FF)
    const looksXML = `
    <category name="${ScratchBlocks.ScratchMsgs.translate('CATEGORY_LOOKS', 'Output')}" toolboxitemid="looks" colour="${col.looks.colourPrimary}" secondaryColour="${col.looks.colourTertiary}">
        <block type="python_print">
            <value name="TEXT">
                <shadow type="text">
                    <field name="TEXT"></field>
                </shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;

    // 2. CONTROL / CONTRÔLE (#FFAB19)
    const controlXML = `
    <category name="${ScratchBlocks.ScratchMsgs.translate('CATEGORY_CONTROL', 'Control')}" toolboxitemid="control" colour="${col.control.colourPrimary}" secondaryColour="${col.control.colourTertiary}">
        <block type="python_if"></block>
        <block type="python_ifelse"></block>
        ${blockSeparator}
        <block type="python_for_in">
            <field name="VAR">item</field>
            <value name="LIST">
                <shadow type="text">
                    <field name="TEXT"></field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="python_while">
            <value name="CONDITION">
                <shadow type="text">
                    <field name="TEXT"></field>
                </shadow>
            </value>
        </block>
        <block type="python_break"></block>
        ${categorySeparator}
    </category>
    `;

    // 3. SENSING / ENTRÉE (#5CB1D6)
    const sensingXML = `
    <category name="${ScratchBlocks.ScratchMsgs.translate('CATEGORY_SENSING', 'Input')}" toolboxitemid="sensing" colour="${col.sensing.colourPrimary}" secondaryColour="${col.sensing.colourTertiary}">
        <block type="python_input">
            <value name="PROMPT">
                <shadow type="text">
                    <field name="TEXT"></field>
                </shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;

    // 4. OPERATORS / OPÉRATEURS (#59C059)
    const operatorsXML = `
    <category name="${ScratchBlocks.ScratchMsgs.translate('CATEGORY_OPERATORS', 'Operators')}" toolboxitemid="operators" colour="${col.operators.colourPrimary}" secondaryColour="${col.operators.colourTertiary}">
        <block type="python_arithmetic">
            <value name="A">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <field name="OP">+</field>
            <value name="B">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="python_round">
            <value name="NUM">
                <shadow type="math_number">
                    <field name="NUM">3.14</field>
                </shadow>
            </value>
        </block>
        <block type="python_abs">
            <value name="NUM">
                <shadow type="math_number">
                    <field name="NUM">-5</field>
                </shadow>
            </value>
        </block>
        <block type="python_min_max">
            <field name="FUNC">min</field>
            <value name="A">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
            <value name="B">
                <shadow type="math_number">
                    <field name="NUM">20</field>
                </shadow>
            </value>
        </block>
        <block type="python_unary">
            <value name="NUM">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="python_compare">
            <value name="A">
                <shadow type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
            <field name="OP">&lt;</field>
            <value name="B">
                <shadow type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        <block type="python_bool_op">
            <value name="A">
                <shadow type="text">
                    <field name="TEXT"></field>
                </shadow>
            </value>
            <field name="OP">and</field>
            <value name="B">
                <shadow type="text">
                    <field name="TEXT"></field>
                </shadow>
            </value>
        </block>
        <block type="python_not">
            <value name="A">
                <shadow type="text">
                    <field name="TEXT"></field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="python_number">
            <field name="NUM">0</field>
        </block>
        <block type="python_string">
            <field name="TEXT">hello</field>
        </block>
        <block type="python_boolean">
            <field name="BOOL">True</field>
        </block>
        <block type="python_none"></block>
        ${blockSeparator}
        <block type="python_cast_int">
            <value name="VAL">
                <shadow type="text">
                    <field name="TEXT">123</field>
                </shadow>
            </value>
        </block>
        <block type="python_cast_float">
            <value name="VAL">
                <shadow type="text">
                    <field name="TEXT">3.14</field>
                </shadow>
            </value>
        </block>
        <block type="python_cast_str">
            <value name="VAL">
                <shadow type="math_number">
                    <field name="NUM">42</field>
                </shadow>
            </value>
        </block>
        <block type="python_cast_bool">
            <value name="VAL">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="python_type">
            <value name="VAL">
                <shadow type="text">
                    <field name="TEXT">x</field>
                </shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;

    // 5. VARIABLES (#FF8C1A)
    const variablesXML = `
    <category name="${ScratchBlocks.ScratchMsgs.translate('CATEGORY_VARIABLES', 'Variables')}" toolboxitemid="variables" colour="${col.variables.colourPrimary}" secondaryColour="${col.variables.colourTertiary}" custom="VARIABLE">
    </category>
    `;

    // 6. LISTS (#FF661A)
    const listsXML = `
    <category name="${ScratchBlocks.ScratchMsgs.translate('CATEGORY_LISTS', 'Lists')}" toolboxitemid="lists" colour="${col.lists.colourPrimary}" secondaryColour="${col.lists.colourTertiary}">
        <block type="python_list_empty"></block>
        <block type="python_list_create_3">
            <value name="A">
                <shadow type="math_number"><field name="NUM">1</field></shadow>
            </value>
            <value name="B">
                <shadow type="math_number"><field name="NUM">2</field></shadow>
            </value>
            <value name="C">
                <shadow type="math_number"><field name="NUM">3</field></shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="python_list_append">
            <value name="LIST">
                <shadow type="text"><field name="TEXT"></field></shadow>
            </value>
            <value name="ITEM">
                <shadow type="math_number"><field name="NUM">10</field></shadow>
            </value>
        </block>
        <block type="python_list_pop">
            <value name="LIST">
                <shadow type="text"><field name="TEXT"></field></shadow>
            </value>
        </block>
        <block type="python_list_remove">
            <value name="LIST">
                <shadow type="text"><field name="TEXT"></field></shadow>
            </value>
            <value name="ITEM">
                <shadow type="math_number"><field name="NUM">10</field></shadow>
            </value>
        </block>
        <block type="python_list_insert">
            <value name="LIST">
                <shadow type="text"><field name="TEXT"></field></shadow>
            </value>
            <value name="INDEX">
                <shadow type="math_number"><field name="NUM">0</field></shadow>
            </value>
            <value name="ITEM">
                <shadow type="text"><field name="TEXT">item</field></shadow>
            </value>
        </block>
        <block type="python_list_get">
            <value name="LIST">
                <shadow type="text"><field name="TEXT"></field></shadow>
            </value>
            <value name="INDEX">
                <shadow type="math_number"><field name="NUM">0</field></shadow>
            </value>
        </block>
        <block type="python_list_set">
            <value name="LIST">
                <shadow type="text"><field name="TEXT"></field></shadow>
            </value>
            <value name="INDEX">
                <shadow type="math_number"><field name="NUM">0</field></shadow>
            </value>
            <value name="VALUE">
                <shadow type="math_number"><field name="NUM">99</field></shadow>
            </value>
        </block>
        <block type="python_list_len">
            <value name="LIST">
                <shadow type="text"><field name="TEXT"></field></shadow>
            </value>
        </block>
        <block type="python_range">
            <value name="STOP">
                <shadow type="math_number"><field name="NUM">10</field></shadow>
            </value>
        </block>
        <block type="python_range_start_stop">
            <value name="START">
                <shadow type="math_number"><field name="NUM">1</field></shadow>
            </value>
            <value name="STOP">
                <shadow type="math_number"><field name="NUM">11</field></shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;

    const everything = [
        xmlOpen,
        looksXML,
        controlXML,
        sensingXML,
        operatorsXML,
        variablesXML,
        listsXML
    ];

    if (categoriesXML && categoriesXML.length > 0) {
        for (const ext of categoriesXML) {
            everything.push(categorySeparator, ext.xml);
        }
    }

    everything.push(xmlClose);
    return everything.join('\n');
};

export default makeToolboxXML;
